var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g4, _path34, _path35, _path36, _path37, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonusHyperCoinStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "200 coins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.1412 19.046C38.1646 16.3725 33.0204 14.1602 26.6513 14.1046C20.2823 14.049 15.1002 16.1712 15.0769 18.8447C15.0536 21.5182 20.1978 23.7306 26.5668 23.7862C32.9359 23.8418 38.1179 21.7195 38.1412 19.046Z",
    fill: "#FF7C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.1708 15.4287L15.1216 15.2275L15.0888 18.9798L38.1381 19.1809L38.1708 15.4287Z",
    fill: "#FF7C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.071 15.2275L15.0396 18.8764C15.0396 18.8764 14.8999 21.1099 19.3194 22.6453L19.4951 18.7221C19.4951 18.7221 15.7883 17.365 15.0712 15.2278L15.071 15.2275Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3418_365357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 14,
    width: 24,
    height: 10
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.1031 19.0782C38.1265 16.4047 32.9823 14.1924 26.6132 14.1368C20.2442 14.0812 15.0622 16.2035 15.0388 18.877C15.0155 21.5505 20.1597 23.7628 26.5287 23.8184C32.8978 23.874 38.0798 21.7518 38.1031 19.0782Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3418_365357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2268 16.2433L25.5229 16.2197L25.4491 24.6815L28.153 24.705L28.2268 16.2433Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5795 16.1826L29.2051 16.127L29.1312 24.5887L35.5057 24.6443L35.5795 16.1826Z",
    fill: "white"
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.166 15.4299C38.1883 12.8819 33.0361 10.7712 26.6583 10.7156C20.2805 10.6599 15.0923 12.6803 15.07 15.2283C15.0478 17.7763 20.2 19.8869 26.5778 19.9426C32.9556 19.9982 38.1438 17.9778 38.166 15.4299Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M26.6624 19.7228C20.3578 19.6675 15.2513 17.604 15.1563 15.0957C15.1529 15.1391 15.151 15.1827 15.1505 15.2265C15.128 17.7746 20.2801 19.8855 26.658 19.9413C33.0358 19.9974 38.2242 17.9771 38.2464 15.4293C38.2466 15.4 38.2459 15.3708 38.2449 15.3415C38.0497 17.8275 32.9306 19.7778 26.6624 19.7228Z",
    fill: "url(#paint0_linear_3418_365357)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.7304 15.1492C34.7446 13.5216 31.1366 12.1705 26.6718 12.1316C22.207 12.0926 18.5761 13.3805 18.5619 15.0081C18.5476 16.6357 22.1556 17.9867 26.6204 18.0256C31.0852 18.0646 34.7162 16.7768 34.7304 15.1492Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M26.648 12.1239C30.9983 12.1622 34.5345 13.4459 34.6997 15.0172C34.7048 14.976 34.7082 14.9346 34.7085 14.8927C34.7229 13.2651 31.115 11.9141 26.6502 11.8749C22.1855 11.8357 18.5545 13.1233 18.5401 14.7509C18.5396 14.7925 18.5423 14.8342 18.5467 14.8754C18.7396 13.3073 22.2976 12.0856 26.648 12.1239Z",
    fill: "url(#paint1_linear_3418_365357)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.699 12.5464C30.8638 12.583 34.2824 13.7612 34.7114 15.2404C34.7141 15.2102 34.716 15.18 34.7163 15.1495C34.7307 13.522 31.1228 12.171 26.658 12.1317C22.1933 12.0925 18.5623 13.3802 18.5479 15.0077C18.5469 15.1171 18.5628 15.2251 18.5937 15.3318C18.7394 13.7476 22.3175 12.5082 26.6987 12.5467L26.699 12.5464Z",
    fill: "#CB6300"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25.7186 13.0581L23.8698 13.0508L23.8642 14.4673L25.713 14.4746L25.7186 13.0581ZM25.7186 13.0581L23.8698 13.0508L23.8642 14.4673L25.713 14.4746L25.7186 13.0581ZM25.7074 15.8919L23.8586 15.8846L23.853 17.3012L25.7018 17.3085L25.7074 15.8919ZM25.7074 15.8919L23.8586 15.8846L23.853 17.3012L25.7018 17.3085L25.7074 15.8919ZM25.7137 14.4746L25.7081 15.8912L27.5569 15.8985L27.5513 17.3155L29.4 17.3229L29.4057 15.9058L29.4113 14.4893L27.5625 14.482L25.7137 14.4746ZM25.7137 14.4746L25.7081 15.8912L27.5569 15.8985L27.5513 17.3155L29.4 17.3229L29.4057 15.9058L29.4113 14.4893L27.5625 14.482L25.7137 14.4746Z",
    fill: "#C15900"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M38.2063 15.4327H38.2046C38.227 12.8847 33.0749 10.7737 26.6971 10.7179C20.3192 10.6619 15.1308 12.6822 15.1087 15.23C15.1074 15.3735 15.1228 15.5156 15.1535 15.6559L15.1291 18.4347C15.096 18.5809 15.0784 18.729 15.0772 18.8788C15.0538 21.5524 20.1979 23.7649 26.5669 23.8209C31.1611 23.8614 35.1376 22.7684 37.0058 21.1528C37.7516 20.5205 38.1731 19.8066 38.1797 19.0487C38.1802 19.0011 38.1787 18.9536 38.1758 18.9066L38.2063 15.433V15.4327Z",
    stroke: "#771B00",
    strokeWidth: 0.902702,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M36.4116 14.2208C36.4349 11.5473 31.2907 9.33497 24.9217 9.27938C18.5527 9.2238 13.3706 11.346 13.3473 14.0195C13.324 16.693 18.4682 18.9054 24.8372 18.961C31.2063 19.0166 36.3883 16.8943 36.4116 14.2208Z",
    fill: "#FF7C00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M36.4402 10.6045L13.391 10.4033L13.3582 14.1556L36.4075 14.3567L36.4402 10.6045Z",
    fill: "#FF7C00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M13.3423 10.4033L13.3109 14.0522C13.3109 14.0522 13.1713 16.2856 17.5908 17.8211L17.7664 13.8979C17.7664 13.8979 14.0596 12.5408 13.3426 10.4036L13.3423 10.4033Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3418_365357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 24,
    height: 10
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M36.3721 14.2531C36.3954 11.5796 31.2512 9.36719 24.8822 9.31161C18.5131 9.25603 13.3311 11.3783 13.3077 14.0518C13.2844 16.7253 18.4286 18.9376 24.7977 18.9932C31.1667 19.0488 36.3487 16.9266 36.3721 14.2531Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3418_365357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_18",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4961 11.4181L23.7922 11.3945L23.7184 19.8563L26.4222 19.8799L26.4961 11.4181Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_19",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8499 11.3574L27.4755 11.3018L27.4016 19.7635L33.7761 19.8191L33.8499 11.3574Z",
    fill: "white"
  })))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M36.4374 10.6056C36.4596 8.05768 31.3074 5.94703 24.9297 5.89137C18.5519 5.83571 13.3636 7.85612 13.3414 10.4041C13.3192 12.952 18.4714 15.0627 24.8491 15.1184C31.2269 15.174 36.4152 13.1536 36.4374 10.6056Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M24.9332 14.8986C18.6287 14.8432 13.5222 12.7798 13.4272 10.2715C13.4238 10.3149 13.4218 10.3585 13.4213 10.4023C13.3989 12.9504 18.551 15.0613 24.9288 15.1171C31.3067 15.1731 36.4951 13.1528 36.5172 10.605C36.5175 10.5758 36.5168 10.5466 36.5158 10.5173C36.3206 13.0032 31.2014 14.9536 24.9332 14.8986Z",
    fill: "url(#paint2_linear_3418_365357)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M33.0022 10.3249C33.0164 8.69734 29.4085 7.34633 24.9437 7.30736C20.4789 7.2684 16.8479 8.55624 16.8337 10.1838C16.8195 11.8114 20.4274 13.1624 24.8922 13.2014C29.357 13.2404 32.988 11.9525 33.0022 10.3249Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M24.9184 7.29968C29.2687 7.33794 32.8049 8.6217 32.9701 10.193C32.9752 10.1518 32.9786 10.1104 32.9789 10.0685C32.9933 8.44092 29.3854 7.0899 24.9206 7.05068C20.4559 7.01145 16.8249 8.29912 16.8105 9.92667C16.81 9.96833 16.8127 10.01 16.8171 10.0512C17.01 8.48307 20.5679 7.26143 24.9184 7.29968Z",
    fill: "url(#paint3_linear_3418_365357)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M24.9708 7.72122C29.1357 7.75777 32.5542 8.93604 32.9833 10.4152C32.9859 10.385 32.9879 10.3548 32.9881 10.3243C33.0025 8.69678 29.3946 7.34576 24.9299 7.30654C20.4651 7.26731 16.8341 8.55498 16.8197 10.1825C16.8188 10.2919 16.8346 10.3999 16.8655 10.5066C17.0112 8.92239 20.5894 7.68297 24.9706 7.72147L24.9708 7.72122Z",
    fill: "#CB6300"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M23.9919 8.23192L22.1432 8.22461L22.1375 9.64116L23.9863 9.64847L23.9919 8.23192ZM23.9919 8.23192L22.1432 8.22461L22.1375 9.64116L23.9863 9.64847L23.9919 8.23192ZM23.9807 11.0658L22.1319 11.0584L22.1263 12.475L23.9751 12.4823L23.9807 11.0658ZM23.9807 11.0658L22.1319 11.0584L22.1263 12.475L23.9751 12.4823L23.9807 11.0658ZM23.987 9.64847L23.9814 11.065L25.8302 11.0723L25.8246 12.4894L27.6734 12.4967L27.679 11.0796L27.6846 9.66309L25.8358 9.65578L23.987 9.64847ZM23.987 9.64847L23.9814 11.065L25.8302 11.0723L25.8246 12.4894L27.6734 12.4967L27.679 11.0796L27.6846 9.66309L25.8358 9.65578L23.987 9.64847Z",
    fill: "#C15900"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M36.4806 10.6046H36.4789C36.5013 8.05655 31.3492 5.9456 24.9713 5.88981C18.5935 5.83377 13.4051 7.85408 13.383 10.4019C13.3817 10.5454 13.3971 10.6874 13.4278 10.8278L13.4034 13.6065C13.3703 13.7527 13.3527 13.9009 13.3515 14.0507C13.3281 16.7242 18.4722 18.9368 24.8412 18.9928C29.4354 19.0333 33.4119 17.9403 35.2801 16.3247C36.0259 15.6924 36.4474 14.9785 36.454 14.2205C36.4545 14.173 36.453 14.1255 36.4501 14.0785L36.4806 10.6048V10.6046Z",
    stroke: "#771B00",
    strokeWidth: 0.902702,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M38.6212 9.29602C38.6445 6.62252 33.5003 4.41016 27.1313 4.35458C20.7623 4.29899 15.5802 6.42124 15.5569 9.09474C15.5336 11.7682 20.6778 13.9806 27.0468 14.0362C33.4158 14.0918 38.5979 11.9695 38.6212 9.29602Z",
    fill: "#FF7C00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M38.6493 5.67967L15.6001 5.47852L15.5674 9.23076L38.6166 9.43191L38.6493 5.67967Z",
    fill: "#FF7C00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M15.5515 5.47852L15.52 9.12735C15.52 9.12735 15.3804 11.3608 19.7999 12.8963L19.9755 8.97312C19.9755 8.97312 16.2687 7.61602 15.5517 5.47876L15.5515 5.47852Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3418_365357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 4,
    width: 24,
    height: 11
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M38.5822 9.32727C38.6055 6.65377 33.4613 4.44141 27.0922 4.38583C20.7232 4.33024 15.5412 6.45249 15.5178 9.12599C15.4945 11.7995 20.6387 14.0119 27.0077 14.0674C33.3768 14.123 38.5588 12.0008 38.5822 9.32727Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3418_365357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_31",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7026 6.49235L25.9988 6.46875L25.9249 14.9305L28.6288 14.9541L28.7026 6.49235Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_32",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0562 6.43258L29.6818 6.37695L29.6079 14.8387L35.9824 14.8943L36.0562 6.43258Z",
    fill: "white"
  })))))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M38.645 5.68182C38.6673 3.13385 33.5151 1.0232 27.1373 0.967544C20.7595 0.911886 15.5713 2.9323 15.5491 5.48026C15.5268 8.02822 20.679 10.1389 27.0568 10.1945C33.4346 10.2502 38.6228 8.22978 38.645 5.68182Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M27.1438 9.9718C20.8393 9.91649 15.7328 7.85306 15.6378 5.34473C15.6343 5.3881 15.6324 5.43171 15.6319 5.47556C15.6095 8.02361 20.7616 10.1346 27.1394 10.1903C33.5173 10.2464 38.7056 8.22608 38.7278 5.67828C38.7281 5.64904 38.7273 5.6198 38.7263 5.59057C38.5312 8.07648 33.412 10.0269 27.1438 9.9718Z",
    fill: "url(#paint4_linear_3418_365357)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M35.2123 5.40111C35.2265 3.77352 31.6186 2.4225 27.1538 2.38354C22.6889 2.34457 19.058 3.63241 19.0438 5.26001C19.0296 6.88761 22.6375 8.23862 27.1023 8.27758C31.5671 8.31655 35.1981 7.02871 35.2123 5.40111Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M27.128 2.37488C31.4783 2.41313 35.0145 3.6969 35.1797 5.26817C35.1848 5.22699 35.1882 5.18557 35.1885 5.14366C35.2028 3.51611 31.595 2.1651 27.1302 2.12587C22.6655 2.08665 19.0345 3.37431 19.0201 5.00186C19.0196 5.04353 19.0223 5.08519 19.0267 5.12637C19.2196 3.55826 22.7775 2.33663 27.128 2.37488Z",
    fill: "url(#paint5_linear_3418_365357)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M27.1814 2.79935C31.3462 2.83589 34.7648 4.01416 35.1938 5.49333C35.1965 5.46312 35.1985 5.43291 35.1987 5.40245C35.2131 3.7749 31.6052 2.42389 27.1405 2.38466C22.6757 2.34544 19.0447 3.6331 19.0303 5.26065C19.0293 5.37005 19.0452 5.47798 19.0761 5.5847C19.2218 4.00052 22.8 2.76109 27.1812 2.79959L27.1814 2.79935Z",
    fill: "#CB6300"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M26.2489 3.18162L24.0383 3.17285L24.0327 4.58941L26.2433 4.59818L26.2489 3.18162ZM26.2489 3.18162L24.0383 3.17285L24.0327 4.58941L26.2433 4.59818L26.2489 3.18162ZM26.2377 6.01546L24.0271 6.00669L24.0215 7.42325L26.2321 7.43202L26.2377 6.01546ZM26.2377 6.01546L24.0271 6.00669L24.0215 7.42325L26.2321 7.43202L26.2377 6.01546ZM26.2442 4.59818L26.2386 6.01473L28.4492 6.0235L28.4436 7.44054L30.6542 7.44932L30.6598 6.03227L30.6654 4.61572L28.4548 4.60695L26.2442 4.59818ZM26.2442 4.59818L26.2386 6.01473L28.4492 6.0235L28.4436 7.44054L30.6542 7.44932L30.6598 6.03227L30.6654 4.61572L28.4548 4.60695L26.2442 4.59818Z",
    fill: "#C15900"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M38.6902 5.68075H38.6884C38.7109 3.13271 33.5588 1.02177 27.1809 0.965972C20.8031 0.910177 15.6147 2.93024 15.5925 5.47804C15.5913 5.62155 15.6067 5.76359 15.6374 5.90393L15.613 8.68271C15.5799 8.8289 15.5623 8.97703 15.5611 9.12687C15.5377 11.8004 20.6818 14.0129 27.0508 14.069C31.645 14.1094 35.6215 13.0164 37.4897 11.4008C38.2355 10.7686 38.657 10.0547 38.6636 9.2967C38.6641 9.24918 38.6626 9.20167 38.6597 9.15465L38.6902 5.681V5.68075Z",
    stroke: "#771B00",
    strokeWidth: 0.902702,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M7.77234 24.0443C8.76494 24.1264 9.7573 24.2085 10.7497 24.2909C13.1242 24.4872 15.586 23.299 17.3541 20.797C20.3619 16.5405 20.2232 10.0934 17.0447 6.39729C15.7343 4.87353 14.1124 4.05513 12.4474 3.91747L9.4698 3.6709C11.1349 3.8088 12.757 4.62696 14.0673 6.15072C17.2462 9.84755 17.3845 16.2942 14.3768 20.5506C12.6087 23.0529 10.1471 24.2411 7.77234 24.0443Z",
    fill: "#FF7C00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M3.17536 21.5631C6.35441 25.2597 11.3693 24.8055 14.3771 20.549C17.3849 16.2928 17.2465 9.84592 14.0677 6.14909C10.8889 2.45275 5.87346 2.90666 2.86593 7.16314C-0.142084 11.4196 -0.00320798 17.8667 3.17536 21.5631Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M4.61479 19.2724C6.89846 21.9279 10.5012 21.6029 12.6631 18.5439C14.8237 15.4864 14.7243 10.8537 12.4406 8.19823C10.1562 5.54177 6.55322 5.86898 4.39259 8.92649C2.23099 11.9857 2.33064 16.6157 4.61479 19.2724Z",
    fill: "url(#paint6_linear_3418_365357)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M4.70867 19.3944C6.99233 22.0499 10.5953 21.7254 12.7569 18.6662C14.9173 15.6084 14.8181 10.9757 12.5342 8.32026C10.2498 5.66379 6.64709 5.99101 4.48646 9.049C2.32462 12.1077 2.42451 16.7382 4.70842 19.3947L4.70867 19.3944Z",
    fill: "#FF9600"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M5.23965 9.41866C3.07805 12.4776 3.1777 17.1079 5.4621 19.7646C5.86411 20.2319 6.30778 20.6052 6.77655 20.8892C6.02808 20.601 5.32127 20.1057 4.709 19.394C2.42484 16.7375 2.32519 12.1073 4.48704 9.04832C6.26734 6.52854 9.02611 5.86509 11.2206 7.19515C9.1762 6.40745 6.82187 7.18054 5.2399 9.41891L5.23965 9.41866Z",
    fill: "#CB6300"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M9.5373 11.8447L11.6994 11.9682L11.8517 9.30517L9.68957 9.18164L9.5373 11.8447ZM9.5373 11.8447L11.6994 11.9682L11.8517 9.30517L9.68957 9.18164L9.5373 11.8447ZM9.23274 17.172L11.3948 17.2955L11.5471 14.6325L9.38502 14.5089L9.23274 17.172ZM9.23274 17.172L11.3948 17.2955L11.5471 14.6325L9.38502 14.5089L9.23274 17.172ZM7.37423 11.7209L5.21215 11.5974L5.05987 14.2604L4.90759 16.9244L7.06968 17.048L7.22196 14.384L9.38405 14.5075L9.53632 11.8444L7.37423 11.7209ZM7.37423 11.7209L5.21215 11.5974L5.05987 14.2604L4.90759 16.9244L7.06968 17.048L7.22196 14.384L9.38405 14.5075L9.53632 11.8444L7.37423 11.7209Z",
    fill: "#C15900"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M14.5359 20.5609C12.7454 23.0941 10.2444 24.2799 7.84253 24.046C10.1956 24.2141 12.6267 23.0268 14.3775 20.549C17.3853 16.2927 17.2469 9.84586 14.0681 6.14903C12.7785 4.64939 11.1865 3.83464 9.54901 3.67773C9.58409 3.68041 9.61869 3.68139 9.65353 3.68407L9.7215 3.68992C11.3537 3.84999 12.9403 4.66547 14.226 6.16097C17.405 9.85756 17.5434 16.3042 14.5356 20.5609H14.5359Z",
    fill: "url(#paint7_linear_3418_365357)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3418_365357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 13,
    height: 22
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M9.26584 3.66504C10.2599 3.72741 11.2535 3.79003 12.2475 3.85216C14.6255 4.00176 16.8892 5.53404 18.2765 8.26555C20.6364 12.9126 19.5654 19.2717 15.8851 22.4689C14.368 23.7867 12.6447 24.3617 10.9772 24.2567L7.99548 24.0696C9.66298 24.1741 11.3865 23.5996 12.9037 22.2817C16.5844 19.0844 17.6547 12.7255 15.295 8.07843C13.908 5.34644 11.6443 3.81439 9.26608 3.66504H9.26584Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3418_365357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_48",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91504 15.8192L22.557 16.833L22.9878 11.0366L9.34578 10.0228L8.91504 15.8192Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_49",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03467 9.00087L22.6766 10.0146L22.8667 7.45685L9.22474 6.44306L9.03467 9.00087Z",
    fill: "white"
  }))))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M17.3099 20.7236C20.3176 16.4672 20.179 10.0201 17.0004 6.32396C16.9602 6.27718 16.9195 6.23088 16.8786 6.18532C16.8633 6.16827 16.8479 6.1517 16.8326 6.13489C16.807 6.10687 16.7814 6.0786 16.7556 6.05107C16.7353 6.02963 16.7149 6.00868 16.6947 5.98748C16.6735 5.96531 16.6525 5.94314 16.6311 5.92121C16.6074 5.89709 16.5836 5.87346 16.5597 5.84982C16.5417 5.83179 16.5236 5.81352 16.5054 5.79573C16.4785 5.76966 16.4515 5.74408 16.4245 5.71825C16.4091 5.70363 16.394 5.68902 16.3787 5.67464C16.3489 5.64662 16.3187 5.61933 16.2888 5.59229C16.2761 5.58084 16.2637 5.56914 16.251 5.55793C16.2181 5.52845 16.185 5.4997 16.1518 5.4712C16.1418 5.46267 16.1321 5.4539 16.1221 5.44537C16.086 5.41467 16.05 5.38446 16.0134 5.35449C16.0064 5.34864 15.9995 5.3428 15.9925 5.33719C15.9533 5.30503 15.9138 5.2736 15.8743 5.24266C15.8704 5.23949 15.8663 5.23632 15.8624 5.23316C15.8197 5.20002 15.7771 5.16737 15.7342 5.13545C15.7332 5.13472 15.7325 5.13424 15.7315 5.1335C14.7036 4.36748 13.5638 3.94013 12.4031 3.84438L9.68286 3.619C9.68066 3.619 9.67871 3.61852 9.67652 3.61827L9.60855 3.61243C9.60392 3.61194 9.59904 3.61194 9.59441 3.61145L9.42752 3.59756C9.01844 3.552 8.60595 3.54737 8.19444 3.58392L8.19322 3.619C6.32692 3.8378 4.4896 4.89936 3.05771 6.77007C3.05601 6.77226 3.0543 6.77446 3.0526 6.77689C3.01629 6.8244 2.98048 6.87216 2.94466 6.92064C2.93857 6.92893 2.93248 6.93746 2.92615 6.94574C2.89106 6.99374 2.85598 7.04222 2.82138 7.09119C2.79214 7.13237 2.76339 7.17403 2.73489 7.2157C2.73391 7.21716 2.73294 7.21862 2.73196 7.21984C-0.120366 11.3847 -0.0216908 17.5582 2.93126 21.2504C2.93687 21.2572 2.94223 21.2643 2.94783 21.2711C2.97098 21.2999 2.99437 21.3286 3.018 21.3571C3.02628 21.3671 3.03432 21.3769 3.04261 21.3868C3.07185 21.4219 3.10133 21.4568 3.13105 21.4914C3.15444 21.5184 3.17783 21.5455 3.20122 21.572C4.50739 23.0534 6.11349 23.846 7.76003 23.9736C8.74191 24.055 9.72379 24.1361 10.7057 24.2178C13.0802 24.4141 15.542 23.2259 17.3101 20.7239L17.3099 20.7236ZM9.43994 3.59878C9.43751 3.59878 9.43507 3.5983 9.43263 3.59805C9.43142 3.59805 9.4302 3.59781 9.42898 3.59756C9.43264 3.59781 9.43629 3.5983 9.43994 3.59854V3.59878Z",
    stroke: "#771B00",
    strokeWidth: 0.902702,
    strokeMiterlimit: 10
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M19.2965 11.1216C19.2965 9.11861 19.1469 8.96901 17.1439 8.96901C19.1469 8.96901 19.2965 8.81941 19.2965 6.81641C19.2965 8.81941 19.4461 8.96901 21.4491 8.96901C19.4461 8.96901 19.2965 9.11861 19.2965 11.1216Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3418_365357",
    x1: 15.1317,
    y1: 17.4671,
    x2: 38.2277,
    y2: 17.6687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3418_365357",
    x1: 18.5534,
    y1: 13.3387,
    x2: 34.7219,
    y2: 13.4798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3418_365357",
    x1: 13.4025,
    y1: 12.643,
    x2: 36.4985,
    y2: 12.8446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3418_365357",
    x1: 16.8234,
    y1: 8.51461,
    x2: 32.9919,
    y2: 8.65571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3418_365357",
    x1: 15.6128,
    y1: 7.71609,
    x2: 38.7088,
    y2: 7.91765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3418_365357",
    x1: 19.0327,
    y1: 3.58964,
    x2: 35.2013,
    y2: 3.73073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3418_365357",
    x1: 12.1007,
    y1: 6.87463,
    x2: 5.09876,
    y2: 20.3635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3418_365357",
    x1: 13.6798,
    y1: 5.1046,
    x2: 10.9349,
    y2: 24.9638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusHyperCoinStack);
export default __webpack_public_path__ + "static/media/bonus-hyper-coin-stack.11621c84e30b8aea6e3f7961bcfe2326.svg";
export { ForwardRef as ReactComponent };